/**
 * Loading component
 */
import { Spin } from 'antd'

interface LoadingProps {
  fullPage?: boolean
  tip?: string
}

export function Loading({ fullPage = false, tip = 'Loading...' }: LoadingProps) {
  if (fullPage) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: '#f5f5f5',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        <Spin size="large" />
        <span style={{ color: '#666' }}>{tip}</span>
      </div>
    )
  }

  return <Spin size="large" tip={tip} />
}

export default Loading
